import { ReactComponent as LifedocsLogo } from 'assets/ld-logo.svg';

import styled from '@emotion/styled';

type LogoProps = {
  height?: number;
};

const Logo = styled(LifedocsLogo)<LogoProps>`
  && {
    height: ${(props) => props.height || 32}px;
    width: auto;
  }
`;

export default Logo;
